export default __webpack_public_path__ + "static/media/failure-icon-23219.a4702042.png";